import { ADD_TASK_BY_ID, ADD_TASK_BY_ID_SUCCESS, ALL_HIGHLIGHTERS, ALL_HIGHLIGHTERS_SUCCESS, CREATE_PROJECT_FAIL, CREATE_PROJECT_ONE, CREATE_PROJECT_ONE_SUCCESS, CREATE_PROJECT_TWO, CREATE_PROJECT_TWO_SUCCESS, EDIT_PROJECT_BY_ID, EDIT_PROJECT_BY_ID_SUCCESS, EDIT_STAGE_BY_ID, EDIT_STAGE_BY_ID_SUCCESS, EDIT_TASK_BY_ID, EDIT_TASK_BY_ID_SUCCESS, ELAPSEDTIME, GET_ALL_BLUEPRINT, GET_ALL_BLUEPRINT_SUCCESS, GET_ALL_DUPLICATE_SUBTASK, GET_ALL_DUPLICATE_SUBTASK_FAILURE, GET_ALL_DUPLICATE_SUBTASK_SUCCESS, GET_ALL_NEEDINFO, GET_ALL_NEEDINFO_SUCCESS, GET_ALL_PROJECT, GET_ALL_PROJECT_MASTERDATA, GET_ALL_PROJECT_MASTERDATA_SUCCESS, GET_ALL_PROJECT_NO_PAGINATION, GET_ALL_PROJECT_NO_PAGINATION_SUCCESS, GET_ALL_PROJECT_SUCCESS, GET_ALL_REVERT_HISTORY, GET_ALL_REVERT_HISTORY_SUCCESS, GET_ALL_SUBTASK, GET_ALL_SUBTASK_FAILURE, GET_ALL_SUBTASK_SAME_TASK, GET_ALL_SUBTASK_SAME_TASK_FAILURE, GET_ALL_SUBTASK_SAME_TASK_SUCCESS, GET_ALL_SUBTASK_SUCCESS, GET_ALL_SUBTASK_SUMMARY, GET_ALL_SUBTASK_SUMMARY_FAILURE, GET_ALL_SUBTASK_SUMMARY_SUCCESS, GET_ALL_TASK_BY_STAGE, GET_ALL_TASK_BY_STAGE_ID, GET_ALL_TASK_BY_STAGE_ID_SUCCESS, GET_ALL_TASK_VIEW, GET_ALL_TASK_VIEW_SUCCESS, GET_GENERAL_TIME_TRACKING, GET_GENERAL_TIME_TRACKING_SUCCESS, GET_HIGHLIGHT_BY_VIEW, GET_HIGHLIGHT_BY_VIEW_SUCCESS, GET_HISTORY_BY_VIEW, GET_HISTORY_BY_VIEW_SUCCESS, GET_LATEST_TIME_BY_ID, GET_LATEST_TIME_BY_ID_SUCCESS, GET_PROJECT_BY_ID, GET_PROJECT_BY_ID_SUCCESS, GET_REVERT_HISTORY, GET_REVERT_HISTORY_SUCCESS, GET_SOW_CHECKLIST, GET_SOW_CHECKLIST_SUCCESS, GET_SOW_FIELDS, GET_SOW_FIELDS_SUCCESS, GET_STAGES_BY_ID, GET_STAGES_BY_ID_SUCCESS, GET_STAGE_BY_PROJECT_ID, GET_STAGE_BY_PROJECT_ID_SUCCESS, GET_STAGE_VIEW, GET_STAGE_VIEW_SUCCESS, GET_TASK_BY_ID, GET_TASK_BY_ID_SUCCESS, GET_TASK_BY_PROJECT_ID, GET_TASK_BY_PROJECT_ID_SUCCESS, GET_TASK_BY_STAGE_ID, GET_TASK_BY_STAGE_ID_SUCCESS, GET_TIME_BY_ID, GET_TIME_BY_ID_SUCCESS, GET_TIME_BY_PROJECT_ID, GET_TIME_BY_PROJECT_ID_SUCCESS, GET_TIME_BY_STAGE_ID, GET_TIME_BY_STAGE_ID_SUCCESS, GET_TIME_SUMMERY, GET_TIME_SUMMERY_SUCCESS, GET_TIME_TRACKING, GET_TIME_TRACKING_SUCCESS, NEED_INFO, NEED_INFO_SUCCESS, PROJECT_ACTION, PROJECT_ACTION_SUCCESS, SET_STAGE_BY_UPDATE_CUSTOM_ORDER, SET_STAGE_BY_UPDATE_CUSTOM_ORDER_SUCCESS, STAGE_ACTION, STAGE_ACTION_SUCCESS, START_TRACKING, START_TRACKING_SUCCESS, STOP_TRACKING, STOP_TRACKING_SUCCESS, UPDATE_ACTION_STATUS_TO_ANY, UPDATE_ACTION_STATUS_TO_ANY_SUCCESS, UPDATE_PROJECT_ATTACHMENT, UPDATE_PROJECT_ROW, UPDATE_STAGE_ATTACHMENT, UPDATE_STAGE_ROW, UPDATE_TASK_ATTACHMENT, UPDATE_TASK_ROW, GET_STAGE_COUNTS_BY_DATE, GET_STAGE_COUNTS_BY_DATE_SUCCESS, CREATE_MEETING_HISTORY, CREATE_MEETING_HISTORY_SUCCESS, GET_ALL_MEETING_HISTORY, GET_ALL_MEETING_HISTORY_SUCCESS, UPDATE_MEETING_HISTORY, UPDATE_MEETING_HISTORY_SUCCESS, CREATE_CONTRACT, CREATE_CONTRACT_SUCCESS, UPDATE_CONTRACT, UPDATE_CONTRACT_SUCCESS, DELETE_CONTRACT, DELETE_CONTRACT_SUCCESS, GET_ALL_CONTRACTS, GET_ALL_CONTRACTS_SUCCESS } from '../storeTypes';
import { IContract } from '../../../@types';

const initialState: any = {
    loader: false,
    error: null,
    createprojectMasterData: {
        allTaskManager: [],
        allArchitect: { data: [] },
        allProjectManagers: [],
        allStages: { data: [] },
        allTask: { data: [] },
        allBlueprints: { data: [0] },
        allTaskWorkers: []
    },
    blueprint: null,
    getproject: {
        name: '',
        projectManager: '',
        architect: '',
        blueprint: '',
        stagesData: [],
        projectSow: {
            id: '', description: '',
            fields: [],
        },
        foldernumber: '',
        quotenumber: '',
        tmquote: false,
        clientEmail: '',
    },
    SowChecklist: [],
    sowfields: [],
    stageView: {
        name: '',
        projectName: '',
        stagesManager: '',
        stagesWorker: '',
        status: null,
        dueDate: '',
        taskNameList: [],
        highlighters: null
    },
    createproject: {
        allTaskWorkers: [],
        allTaskManager: [],
        promise: undefined,
        allArchitect: {
            data: []
        },
        allProjectManagers: [],
        allStages: {
            data: []
        },
        allTask: {
            data: []
        },
        allBlueprints: {
            values: undefined,
            data: []
        }
    },
    projectList: undefined,
    needInfoView: {},
    taskView: {},
    projectData: {},
    meetingHistory: [],
    caPhaseHistory: [],
    stagesView: {},
    tasksView: {},
    startTracking: {},
    stopTracking: {},
    spentTime: [],
    Latesttime: [],
    highlighters: [],
    taskbyproject: [],
    stagebyproject: [],
    stageAllTaskView: [],
    highlighterByView: null,
    historyView: null,
    revertHistory: null,
    elapsedTime: "00:00:00",
    timeSummery: null,
    timeTracking: null,
    generalTimeTracking: null,
    AllSubtask: {},
    allSubtaskSummary: {},
    allSubtaskSametask: {},
    allDuplicateSubtasks: null,
    stageLoader: false,
    updateStatusAny: null,
    isLoader: false,
    stageCounts: null,
    historyLoader: false
}
const ProjectMasterDataReducer = (state = initialState, action: any) => {
    // console.log('getAllProjectMasterData 5--', action);

    switch (action.type) {
        case GET_ALL_PROJECT_MASTERDATA:
            return {
                ...state,
                loader: true,
            };
        case GET_ALL_PROJECT_MASTERDATA_SUCCESS:
            // console.log('check77', action);
            return {
                ...state,
                loader: false,
                createprojectMasterData: action?.payload,
            };
        case EDIT_PROJECT_BY_ID:
            return {
                ...state,
                loader: true,
            }
        case EDIT_PROJECT_BY_ID_SUCCESS: {
            const updatedGetproject = { ...state.getproject, ...action.payload };
            if (action.payload && typeof action.payload.clientEmailId === 'string' && action.payload.clientEmailId) {
                updatedGetproject.clientEmailId = {
                    _id: action.payload.clientEmailId,
                    name: action.payload.clientContactPerson || (typeof state.getproject?.clientEmailId === 'object' ? state.getproject?.clientEmailId?.name : ''),
                    email: action.payload.clientEmail || (typeof state.getproject?.clientEmailId === 'object' ? state.getproject?.clientEmailId?.email : '')
                };
            }
            return {
                ...state,
                createproject: action?.payload,
                getproject: updatedGetproject,
                loader: false,
                historyView: null
            }
        }
        case EDIT_STAGE_BY_ID:
            return {
                ...state,
                loader: true,
            }
        case EDIT_STAGE_BY_ID_SUCCESS:
            const updatedStage = action?.payload;
            return {
                ...state,
                loader: false,
                historyView: null,
                // stagesView: action?.payload
                stagesView: { ...state.stagesView, ...updatedStage },
                stageAllTaskView: state.stageAllTaskView?.map((task: any) =>
                    task.stageDataId?._id === updatedStage?._id
                        ? { ...task, stageDataId: { ...task.stageDataId, ...updatedStage } }
                        : task
                )
            }
        case EDIT_TASK_BY_ID:
            return {
                ...state,
                loader: true,
            }
        case EDIT_TASK_BY_ID_SUCCESS:
            return {
                ...state,
                loader: false,
                tasksView: action?.payload,
                historyView: null
            }
        case ADD_TASK_BY_ID:
            return {
                ...state,
                loader: true,
            }
        case ADD_TASK_BY_ID_SUCCESS:
            return {
                ...state,
                loader: false,
            }
        case UPDATE_PROJECT_ROW:
            // console.log(action?.payload, "checkboth", state?.projectList);
            let updatedProjectData = state?.projectList?.data?.map((value: any) => {
                return value._id === action?.payload?.id ? action?.payload.data : value
            })
            // console.log(updatedProjectData, "check125");
            return {
                ...state,
                projectList: { ...state?.projectList, data: updatedProjectData },
            };
        case UPDATE_PROJECT_ATTACHMENT:
            return {
                ...state,
                getproject: { ...state?.getproject, attachments: action.payload },
            };
        case UPDATE_STAGE_ROW:
            // console.log(action?.payload, "checkbothstage", state?.stageView);
            let updatedStageData = state?.stageView?.data?.map((value: any) => {
                return value._id === action?.payload?.id ? action?.payload.data : value
            })
            // console.log(updatedStageData, "check125");
            return {
                ...state,
                stageView: { ...state?.stageView, data: updatedStageData },
            };
        case UPDATE_STAGE_ATTACHMENT:
            return {
                ...state,
                stagesView: { ...state?.stagesView, attachments: action.payload },
            };
        case UPDATE_TASK_ATTACHMENT:
            return {
                ...state,
                tasksView: { ...state?.tasksView, attachments: action.payload },
            };
        case UPDATE_TASK_ROW:
            // console.log(action?.payload, "checkbothstage", state?.taskView);
            let updatedTaskData = state?.taskView?.data?.map((value: any) => {
                return value._id === action?.payload?.id ? action?.payload.data : value
            })
            // console.log(updatedTaskData, "check125");
            return {
                ...state,
                taskView: { ...state?.taskView, data: updatedTaskData },
            };
        case GET_ALL_PROJECT:
            return {
                ...state,
                loader: true,
            };
        case GET_ALL_PROJECT_SUCCESS:
            return {
                ...state,
                loader: false,
                projectList: action?.payload,
            };
        case GET_ALL_PROJECT_NO_PAGINATION:
            return {
                ...state,
                loader: true
            }
        case GET_ALL_PROJECT_NO_PAGINATION_SUCCESS:
            return {
                ...state,
                loader: false,
                projectData: action?.payload
            }
        case GET_ALL_TASK_VIEW:
            return {
                ...state,
                loader: true,
            };
        case GET_ALL_TASK_VIEW_SUCCESS:
            return {
                ...state,
                loader: false,
                taskView: action?.payload,
            };
        case GET_ALL_NEEDINFO:
            return {
                ...state,
                loader: true,
            };
        case GET_ALL_NEEDINFO_SUCCESS:
            return {
                ...state,
                loader: false,
                needInfoView: action?.payload,
            };
        case GET_TIME_SUMMERY:
            return {
                ...state,
                isLoader: true,
            };
        case GET_TIME_SUMMERY_SUCCESS:
            return {
                ...state,
                isLoader: false,
                timeSummery: action?.payload,
            };
        case GET_TIME_TRACKING:
            return {
                ...state,
                loader: true,
            };
        case GET_TIME_TRACKING_SUCCESS:
            return {
                ...state,
                loader: false,
                timeTracking: action?.payload,
            };
        case GET_GENERAL_TIME_TRACKING:
            return {
                ...state,
                loader: true,
            };
        case GET_GENERAL_TIME_TRACKING_SUCCESS:
            return {
                ...state,
                loader: false,
                generalTimeTracking: action?.payload,
            };
        case GET_STAGE_VIEW:
            return {
                ...state,
                loader: true,
            };
        case GET_STAGE_VIEW_SUCCESS:

            return {
                ...state,
                loader: false,
                stageView: action?.payload,
            };

        case GET_ALL_BLUEPRINT:
            return {
                ...state,
                loader: true,
            };
        case GET_ALL_BLUEPRINT_SUCCESS:
            return {
                ...state,
                loader: false,
                createproject: action.payload,
            };
        case CREATE_PROJECT_ONE:
            return {
                ...state,
                loader: true
            }
        case CREATE_PROJECT_ONE_SUCCESS:
            return {
                ...state,
                loader: false,
                createproject: action.payload,
            }
        case CREATE_PROJECT_FAIL:
            return {
                ...state,
                loader: false,
                isStageLoader: false,
                error: action.payload
            }
        case NEED_INFO:
            return {
                ...state,
                loader: true
            }
        case NEED_INFO_SUCCESS:
            return {
                ...state,
                loader: false
            }

        case STAGE_ACTION:
            return {
                ...state,
                loader: true
            }
        case STAGE_ACTION_SUCCESS:
            return {
                ...state,
                loader: false
            }

        case PROJECT_ACTION:
            return {
                ...state,
                loader: true
            }
        case PROJECT_ACTION_SUCCESS:
            return {
                ...state,
                loader: false
            }

        case CREATE_PROJECT_TWO:
            return {
                ...state,
                loader: true,
                isStageLoader: true
            }
        case CREATE_PROJECT_TWO_SUCCESS:
            return {
                ...state,
                loader: true,
                isStageLoader: false,
                createproject: action.payload,
            }
        case GET_PROJECT_BY_ID:
            return {
                ...state,
                loader: true
            }
        case GET_PROJECT_BY_ID_SUCCESS:
            return {
                ...state,
                loader: false,
                getproject: action.payload
            }
        case GET_STAGES_BY_ID:
            return {
                ...state,
                loader: true,
            }
        case GET_STAGES_BY_ID_SUCCESS:
            return {
                ...state,
                loader: false,
                stagesView: action?.payload
            }
        case GET_TASK_BY_STAGE_ID:
            return {
                ...state,
                loader: true
            }
        case GET_TASK_BY_STAGE_ID_SUCCESS:
            return {
                ...state,
                loader: false,
                tasksView: action?.payload
            }
        case GET_TASK_BY_PROJECT_ID:
            return {
                ...state,
                loader: true
            }
        case GET_TASK_BY_PROJECT_ID_SUCCESS:
            return {
                ...state,
                loader: false,
                taskbyproject: action?.payload
            }
        case GET_STAGE_BY_PROJECT_ID:
            return {
                ...state,
                loader: true
            }
        case GET_STAGE_BY_PROJECT_ID_SUCCESS:
            return {
                ...state,
                loader: false,
                stagebyproject: action?.payload
            }
        case SET_STAGE_BY_UPDATE_CUSTOM_ORDER:
            return {
                ...state,
                loader: true
            }
        case SET_STAGE_BY_UPDATE_CUSTOM_ORDER_SUCCESS:
            return {
                ...state,
                loader: false,
            }
        case GET_TIME_BY_ID:
            return {
                ...state,
                loader: true
            }
        case GET_TIME_BY_ID_SUCCESS:
            return {
                ...state,
                loader: false,
                spentTime: action?.payload
            }
        case GET_TIME_BY_STAGE_ID:
            return {
                ...state,
                loader: true
            }
        case GET_TIME_BY_STAGE_ID_SUCCESS:
            return {
                ...state,
                loader: false,
                spentTime: action?.payload
            }
        case GET_TIME_BY_PROJECT_ID:
            return {
                ...state,
                loader: true
            }
        case GET_TIME_BY_PROJECT_ID_SUCCESS:
            return {
                ...state,
                loader: false,
                spentTime: action?.payload
            }
        case GET_LATEST_TIME_BY_ID:
            return {
                ...state,
                loader: true
            }
        case GET_LATEST_TIME_BY_ID_SUCCESS:
            return {
                ...state,
                loader: false,
                Latesttime: action?.payload
            }
        case GET_TASK_BY_ID:
            return {
                ...state,
                loader: true
            }
        case GET_TASK_BY_ID_SUCCESS:
            return {
                ...state,
                loader: false,
                tasksView: action?.payload
            }
        case GET_SOW_CHECKLIST:
            return {
                ...state,
                loader: true
            }
        case GET_SOW_CHECKLIST_SUCCESS:
            return {
                ...state,
                loader: false,
                SowChecklist: action.payload
            }
        case GET_SOW_FIELDS:
            return {
                ...state,
                loader: true
            }
        case GET_SOW_FIELDS_SUCCESS:
            // console.log("check751", action.payload);
            return {
                ...state,
                loader: false,
                sowfields: action.payload
            }
        case START_TRACKING:
            return {
                ...state
            }
        case START_TRACKING_SUCCESS:
            return {
                ...state,
                startTracking: action?.payload
            }
        case STOP_TRACKING:
            return {
                ...state
            }
        case STOP_TRACKING_SUCCESS:
            return {
                ...state,
                stopTracking: action?.payload
            }
        case ALL_HIGHLIGHTERS:
            return {
                ...state
            }
        case ALL_HIGHLIGHTERS_SUCCESS:
            return {
                ...state,
                highlighters: action?.payload
            }
        case GET_HIGHLIGHT_BY_VIEW:
            return {
                ...state,
                loader: true
            }
        case GET_HIGHLIGHT_BY_VIEW_SUCCESS:
            return {
                ...state,
                loader: false,
                highlighterByView: action?.payload
            }
        case GET_ALL_TASK_BY_STAGE_ID:
            return {
                ...state,
                loader: true
            }
        case GET_ALL_TASK_BY_STAGE:
            return {
                ...state,
                stageLoader: true
            }
        case GET_ALL_TASK_BY_STAGE_ID_SUCCESS:
            return {
                ...state,
                loader: false,
                stageLoader: false,
                stageAllTaskView: action?.payload
            }
        case GET_HISTORY_BY_VIEW:
            const isFirstPage = typeof action.payload === 'string' && (action.payload.includes('page=1') || !action.payload.includes('page='));
            return {
                ...state,
                historyLoader: true,
                historyView: isFirstPage ? null : state.historyView
            }
        case GET_HISTORY_BY_VIEW_SUCCESS:
            return {
                ...state,
                historyLoader: false,
                historyView: action?.payload
            }
        case GET_REVERT_HISTORY:
            return {
                ...state,
                loader: true
            }
        case GET_REVERT_HISTORY_SUCCESS:
            return {
                ...state,
                loader: false,
                revertHistory: action?.payload
            }
        case GET_ALL_REVERT_HISTORY:
            return {
                ...state,
                loader: true
            }
        case GET_ALL_REVERT_HISTORY_SUCCESS:
            return {
                ...state,
                loader: false,
                allHistoryrevert: action?.payload
            }
        case ELAPSEDTIME:
            return {
                ...state,
                elapsedTime: action?.payload
            }
        case GET_ALL_SUBTASK:
            return {
                ...state,
                loader: true,
                // AllSubtask: {}
            }
        case GET_ALL_SUBTASK_SUCCESS:
            return {
                ...state,
                loader: false,
                AllSubtask: action?.payload
            }
        case GET_ALL_SUBTASK_FAILURE:
            return {
                ...state,
                loader: false,
                AllSubtask: { ...(state.AllSubtask || {}), isLoaded: true }
            }
        case GET_ALL_SUBTASK_SUMMARY:
            return {
                ...state,
                loader: true
            }
        case GET_ALL_SUBTASK_SUMMARY_SUCCESS:
            return {
                ...state,
                loader: false,
                allSubtaskSummary: action?.payload
            }
        case GET_ALL_SUBTASK_SUMMARY_FAILURE:
            return {
                ...state,
                loader: false
            }
        case GET_ALL_SUBTASK_SAME_TASK:
            return {
                ...state,
                loader: true
            }
        case GET_ALL_SUBTASK_SAME_TASK_SUCCESS:
            return {
                ...state,
                loader: false,
                allSubtaskSametask: action?.payload
            }
        case GET_ALL_SUBTASK_SAME_TASK_FAILURE:
            return {
                ...state,
                loader: false
            }
        case GET_ALL_DUPLICATE_SUBTASK:
            return {
                ...state,
                loader: true
            }
        case GET_ALL_DUPLICATE_SUBTASK_SUCCESS:
            return {
                ...state,
                loader: false,
                allDuplicateSubtasks: action?.payload
            }
        case GET_ALL_DUPLICATE_SUBTASK_FAILURE:
            return {
                ...state,
                loader: false,
                allDuplicateSubtasks: { ...(state.allDuplicateSubtasks || {}), isLoaded: true }
            }
        case UPDATE_ACTION_STATUS_TO_ANY:
            return {
                ...state,
                loader: true
            }
        case UPDATE_ACTION_STATUS_TO_ANY_SUCCESS:
            return {
                ...state,
                loader: false,
                updateStatusAny: action?.payload
            }
        case GET_STAGE_COUNTS_BY_DATE:
            return {
                ...state,
                loader: true
            }
        case GET_STAGE_COUNTS_BY_DATE_SUCCESS:
            return {
                ...state,
                loader: false,
                stageCounts: action?.payload?.data
            }
        case CREATE_MEETING_HISTORY:
            return {
                ...state,
                loader: true
            }
        case GET_ALL_MEETING_HISTORY:
            return {
                ...state,
                historyLoader: true
            }
        case CREATE_MEETING_HISTORY_SUCCESS:
            const newData = action.payload?.data;
            const isMeetingType = newData?.type === 'MEETING';
            return {
                ...state,
                loader: false,
                meetingHistory: isMeetingType ? [newData, ...state.meetingHistory] : state.meetingHistory,
                caPhaseHistory: !isMeetingType ? [newData, ...state.caPhaseHistory] : state.caPhaseHistory,
                getproject: {
                    ...state.getproject,
                    // meetings: isMeetingType ? (state.getproject.meetings || 0) + 1 : state.getproject.meetings,
                    // CA_Phase: !isMeetingType ? (state.getproject.CA_Phase || 0) + 1 : state.getproject.CA_Phase,
                    meetings: isMeetingType ? (newData?.meetings ?? (state.getproject.meetings || 0) + 1) : state.getproject.meetings,
                    CA_Phase: !isMeetingType ? (newData?.CA_Phase ?? newData?.caphases ?? (state.getproject.CA_Phase || 0) + 1) : state.getproject.CA_Phase,
                }
            }
        case GET_ALL_MEETING_HISTORY_SUCCESS:
            return {
                ...state,
                historyLoader: false,
                meetingHistory: action.payload?.data?.filter((item: any) => item.type === 'MEETING') || [],
                caPhaseHistory: action.payload?.data?.filter((item: any) => item.type === 'CA_PHASE') || [],
            }
        case UPDATE_MEETING_HISTORY:
            return {
                ...state,
                loader: true
            }
        case UPDATE_MEETING_HISTORY_SUCCESS:
            const updatedEntry = action.payload?.data;
            const isMeeting = updatedEntry?.type === 'MEETING';
            return {
                ...state,
                loader: false,
                meetingHistory: isMeeting
                    ? state.meetingHistory.map((h: any) => h._id === updatedEntry?._id ? updatedEntry : h)
                    : state.meetingHistory,
                caPhaseHistory: !isMeeting
                    ? state.caPhaseHistory.map((h: any) => h._id === updatedEntry?._id ? updatedEntry : h)
                    : state.caPhaseHistory,
            }
        case CREATE_CONTRACT:
            return {
                ...state,
                loader: true
            }
        case CREATE_CONTRACT_SUCCESS:
            return {
                ...state,
                getproject: {
                    ...state.getproject,
                    contracts: [...(state.getproject.contracts || []), action.payload]
                },
                loader: false
            }
        case UPDATE_CONTRACT:
            return {
                ...state,
                loader: true
            }
        case UPDATE_CONTRACT_SUCCESS:
            return {
                ...state,
                getproject: {
                    ...state.getproject,
                    contracts: (state.getproject.contracts || []).map((c: IContract) =>
                        c._id === action.payload._id ? action.payload : c
                    )
                },
                loader: false
            }
        case DELETE_CONTRACT:
            return {
                ...state,
                loader: true
            }
        case DELETE_CONTRACT_SUCCESS:
            return {
                ...state,
                getproject: {
                    ...state.getproject,
                    contracts: (state.getproject.contracts || []).filter((c: IContract) =>
                        c._id !== action.payload
                    )
                },
                loader: false
            }
        case GET_ALL_CONTRACTS:
            return {
                ...state,
                loader: true
            }
        case GET_ALL_CONTRACTS_SUCCESS:
            return {
                ...state,
                getproject: {
                    ...state.getproject,
                    contracts: action.payload
                },
                loader: false
            }
        default:
            return state;
    }
};

export default ProjectMasterDataReducer;